import React, { useEffect } from 'react';
import '../components/converge/converge.css';
import { ConvergeNav } from '../components/converge/ConvergeNav';
import { ConvergeHero } from '../components/converge/ConvergeHero';
import { ConvergePrizes } from '../components/converge/ConvergePrizes';
import { ConvergeWorkshop } from '../components/converge/ConvergeWorkshop';
import { ConvergeThemes } from '../components/converge/ConvergeThemes';
import { ConvergeRounds } from '../components/converge/ConvergeRounds';
import { ConvergeTimeline } from '../components/converge/ConvergeTimeline';
import { ConvergeMentors } from '../components/converge/ConvergeMentors';
import { ConvergeConclave } from '../components/converge/ConvergeConclave';
import { ConvergeWhy } from '../components/converge/ConvergeWhy';
import { ConvergeFinalCta, ConvergeFooter } from '../components/converge/ConvergeFooter';

const TITLE = 'CONVERGE by EvalentX — National-Level Hackathon · 16–17 Nov 2026 · In association with AARUUSH · SRM IST, Chennai';
const DESC = '24-hour national-level hackathon, AI & Agentic AI workshop and HR Conclave in association with AARUUSH at SRM Institute of Science and Technology, Kattankulathur. ₹2,50,000 prize pool in cash and goodies.';
const META = [
  ['name', 'description', DESC], ['property', 'og:title', TITLE], ['property', 'og:description', DESC],
  ['property', 'og:type', 'website'], ['property', 'og:image', '/converge-og.png'],
  ['property', 'og:image:width', '1200'], ['property', 'og:image:height', '630'], ['property', 'og:image:type', 'image/png'],
  ['name', 'twitter:card', 'summary_large_image'], ['name', 'twitter:image', '/converge-og.png'], ['name', 'twitter:title', TITLE], ['name', 'twitter:description', DESC],
];

const usePageMeta = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = TITLE;
    const restore = META.map(([attr, key, value]) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      const created = !el;
      if (created) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
      const prev = el.getAttribute('content');
      el.setAttribute('content', value.startsWith('/') ? `${window.location.origin}${value}` : value);
      return () => (created ? el.remove() : el.setAttribute('content', prev || ''));
    });
    return () => { document.title = prevTitle; restore.forEach((fn) => fn()); };
  }, []);
};

export default function HackathonPage() {
  usePageMeta();
  return (
    <div className="cv-root min-h-screen" data-testid="converge-page">
      <a href="#overview" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 bg-[#D7FF38] border-2 border-[#111] px-3 py-2 font-bold">Skip to content</a>
      <ConvergeNav />
      <main>
        <ConvergeHero />
        <ConvergePrizes />
        <ConvergeWorkshop />
        <ConvergeThemes />
        <ConvergeRounds />
        <ConvergeMentors />
        <ConvergeTimeline />
        <ConvergeConclave />
        <ConvergeWhy />
        <ConvergeFinalCta />
      </main>
      <ConvergeFooter />
    </div>
  );
}
